function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15,10h-1H6H5c-1.7,0-3,1.3-3,3v5h4h8h4v-5C18,11.3,16.7,10,15,10z M16,16h-2v-2H6v2H4v-3c0-0.5,0.5-1,1-1h10 c0.5,0,1,0.5,1,1V16z M19.7,4.7C16.7,1.8,14.5,0,10,0S3.3,1.8,0.3,4.7C0.1,4.8,0,5.1,0,5.4c0,0.3,0.1,0.5,0.3,0.7l2.5,2.5 c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3C5,7.8,5.9,7.2,6.8,6.7c0.3-0.2,0.6-0.5,0.6-0.9V2.7C7.7,2.6,8,2.5,8.3,2.4 c1.1-0.3,2.2-0.3,3.3,0c0.3,0.1,0.6,0.2,0.9,0.3v3.1c0,0.4,0.2,0.7,0.6,0.9c1,0.5,1.9,1.1,2.7,1.9c0.2,0.2,0.4,0.3,0.7,0.3 c0.3,0,0.5-0.1,0.7-0.3l2.5-2.5C19.9,5.9,20,5.6,20,5.4C20,5.1,19.9,4.8,19.7,4.7z M5.4,5.2L5.4,5.2C4.7,5.6,4.1,6,3.5,6.5L2.5,5.4 C3.4,4.7,4.4,4,5.4,3.5V5.2z M16.5,6.5c-0.6-0.5-1.2-0.9-1.9-1.3V3.5c1.1,0.5,2,1.2,3,1.9L16.5,6.5z"
});

var SvgHomePhone = function SvgHomePhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18",
    style: {
      enableBackground: "new 0 0 20 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomePhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home_phone.70c14223.svg";
export { ForwardRef as ReactComponent };